/**
 * Utilities for working with type definitions in TypeScript modules.
 *
 * @note The functions provided by this module require the `typescript` peer dependency.
 *
 * @module @sorrell/utilities/type
 */
/**
 * @file      index.ts
 * @author    Gage Sorrell <gage@sorrell.sh>
 * @copyright (c) 2026 Gage Sorrell
 * @license   MIT
 */
export * from "./Test.ts";
export * from "./Test.Types.ts";
export * from "./Utility.Types.ts";
